// Centralized helpers for identity & ownership checks across the app

export type AuthorLike = {
  author_id?: string | null;
  user_id?: string | null;   // legacy schema field
  author?: string | null;    // legacy client-mapped field
};

export const getAuthorId = (obj: AuthorLike | null | undefined): string | undefined => {
  if (!obj) return undefined;
  // Prefer the canonical "author_id" (we'll alias to it in services)
  return (obj.author_id || obj.user_id || obj.author || undefined) || undefined;
};

export const isOwnedBy = (obj: AuthorLike | null | undefined, currentUserId?: string | null): boolean => {
  if (!currentUserId) return false;
  const authorId = getAuthorId(obj);
  return !!authorId && authorId === currentUserId;
};